import { render, staticRenderFns } from "./UniversityGraduateQuestion.vue?vue&type=template&id=4ada8883"
import script from "./UniversityGraduateQuestion.vue?vue&type=script&lang=js"
export * from "./UniversityGraduateQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports